module.exports = __webpack_public_path__ + "static/media/guide-smell-3.001303c4.svg";